<template>
  <section>
    <el-form :model="formObj" :rules="fromRules" ref="formObj" label-width="120px">
      <el-form-item label="所属公司" prop="comId">
        <div v-if="isShowTree">
          <CompanyList @comSelected="comSelected" :com-name="formObj.comName" :com-id="formObj.comId" :option="option" ></CompanyList>
        </div>
      </el-form-item>
      <el-form-item label="项目名称" prop="proName">
        <el-input v-model="formObj.proName" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="建筑面积" prop="proTab1">
        <el-input v-model="formObj.proTab1" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="结构形式" prop="proTab2">
        <el-input v-model="formObj.proTab2" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="总层数" prop="proTab3">
        <el-input v-model="formObj.proTab3" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="建设单位" prop="proTab4">
        <el-input v-model="formObj.proTab4" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="代建单位" prop="proTab4">
        <el-input v-model="formObj.proTab9" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="监理单位" prop="proTab5">
        <el-input v-model="formObj.proTab5" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="安监站" prop="proTab6">
        <el-input v-model="formObj.proTab6" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="质监站" prop="proTab6">
        <el-input v-model="formObj.proTab8" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="总承包单位" prop="proTab7">
        <el-input v-model="formObj.proTab7" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="项目负责人" prop="proPerson">
        <el-input v-model="formObj.proPerson" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>

      <el-form-item label="项目效果图" prop="proPhoto">
        <el-upload
          :action="this.GLOBAL.baseServerPath+'/imgupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          list-type="picture-card"
          :limit="5"
          :on-exceed="handleExceed"
          :on-remove="fileRemove"
          :on-success="fileSuccess"
          :file-list="fileList">
          <div class="pic_btn"><i class="el-icon-plus"></i></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="项目设计图" prop="proPhoto">
        <el-upload
          :action="this.GLOBAL.baseServerPath+'/imgupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          list-type="picture-card"
          :limit="1"
          :on-exceed="handleDesignExceed"
          :on-remove="removeDesignUpload"
          :on-success="successDesignUpload"
          :file-list="designList">
          <div class="pic_btn"><i class="el-icon-plus"></i></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="项目视频" prop="proVoid">
        <el-upload
          class="upload-demo"
          :action="this.GLOBAL.baseServerPath+'/fileupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          :limit="1"
          :on-exceed="handleDesignExceed"
          :on-success="successVoidUpload"
          :on-remove="removeVoidUpload"
          :file-list="voidList"
          >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import CompanyList from './CompanyList'
  import {proCreate,proUpdate} from '../../api/api'

  export default {
    name: "ProjectForm",
    components: {CompanyList},
    props: {
      option: 0,
      formData:{}
    },
    data() {
      return {
        formObj: {comParent:0},//如果不选择上级公司默认为总公司
        fromRules: {
          proName: [
            {required: true, message: '请输入项目名称', trigger: 'blur'}
          ],
          proPerson: [
            {required: true, message: '请输入项目负责人', trigger: 'blur'}
          ],
          comId: [
            {required: true, message: '请选择所属公司', trigger: 'blur'}
          ],
        },
        fileList: [],
        isShowTree:false,
        comId:null,
        comName:null,
        imgList:[],
        voidList:[],
        designList:[],
      }
    },
    methods: {
      //删除上传图片
      fileRemove(file, fileList) {
        if (this.option == 0) {
          let n = this.imgList.indexOf(file.response.data);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
        } else {
          let index = file.url.lastIndexOf("/");
          file.url = file.url.substring(index - 9, file.url.length);
          let n = this.imgList.indexOf(file.url);
          let m = this.fileList.indexOf(file);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
          if (m > -1) {
            this.fileList.splice(m, 1);
          }
        }
      },
      //图片上传成功
      fileSuccess(response, file, fileList) {
        //console.log(response.data)
        this.imgList.push(response.data);
      },
      //上传视频成功
      successVoidUpload:function(response){
        this.formObj.proVoid = response.data;
      },
      removeVoidUpload:function(){
        this.formObj.proVoid =null;
      },
      //上传设计图成功
      successDesignUpload:function(response){
        this.formObj.proDesign = response.data;
        console.log(this.formObj.proDesign);
      },
      removeDesignUpload:function(){
        this.formObj.proDesign =null;
      },
      //上传限制
      handleExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //上传限制
      handleDesignExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      doSubmit: function (option) {
        if(this.comId==0 || this.comId == null)
        {
          this.$message({
            message: "请选择所属公司",
            type: 'error'
          });
          return ;
        }
        this.formObj.comId = this.comId;
        this.formObj.comName=this.comName;
        this.formObj.proPhoto = this.imgList.join(",");
        // console.log(this.formObj)
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {

              if (option == 0) {
                proCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
              else if (option == 1) {
                proUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      comSelected:function(id,value){
        this.comId = id;
        this.comName = value;
      }
    },
    mounted() {
      this.isShowTree=true;
      this.formObj = this.formData;
      if(this.formObj.proPhoto!=null && this.formObj.proPhoto!='' && this.option ==1) {
        this.imgList = this.formObj.proPhoto.split(',');

        for (let i = 0; i <this.imgList.length ; i++) {
          this.fileList.push({url: this.GLOBAL.basePhotoPath + "" + this.imgList[i]});
        }
      }
      if(this.formObj.proVoid!=null && this.formObj.proVoid!='' && this.option ==1){
        this.voidList.push({url: this.GLOBAL.baseFilePath + "" + this.formObj.proVoid});
      }
      if(this.formObj.proDesign!=null && this.formObj.proDesign!='' && this.option ==1){
        this.designList.push({url: this.GLOBAL.basePhotoPath + "" + this.formObj.proDesign});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sysmanager/ProjectForm.vue